import React, { useContext, useEffect, useState } from 'react';
import './ReceptionPage.scss';
import WifiInfo from '../components/WifiInfo';
import { AppStore, GooglePlay } from '../icons';
import TodayDateTime from '../components/TodayDateTime';
import PeopleInOffice from '../components/PeopleInOffice';
import { api } from '../services/http';
import set from 'date-fns/set';
import MainLayout from '../components/MainLayout';
import { Trans } from 'react-i18next';
import { DeviceAuthContext } from '@inspace-org/react-auth';

const SHOW_USERS_LENGTH = 6;

const ReceptionPage = () => {
  const { settings, branding } = useContext(DeviceAuthContext);
  const [usersAvatar, setUsersAvatar] = useState([]);
  const [countUsers, setCountUsers] = useState(0);
  const startTime = set(new Date(), { hours: 0, minutes: 0, seconds: 0 }).toISOString();
  const endTime = set(new Date(), { hours: 23, minutes: 59, seconds: 59 }).toISOString();

  const getUsersAvatar = async () => {
    try {
      await api
        .get('/v2/dashboard', {
          'dates[0][startTime]': startTime,
          'dates[0][endTime]': endTime,
          usersInBookings: SHOW_USERS_LENGTH,
          requireAvatars: true,
        })
        .then((res) => {
          setUsersAvatar(res.usersInBookings.list.map((el) => el.avatar));
          setCountUsers(res.usersInBookings.count);
        });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      getUsersAvatar();
    }, 10000);
    return () => clearInterval(interval);
  });

  useEffect(() => {
    getUsersAvatar();
  }, []);

  return (
    <MainLayout
      logoImg={branding.fullLogo}
      type={'reception'}
      bgImage={settings.panel.bgImage}
      childrenLeft={
        <div className="reception">
          <div className="reception__title">
            <p>{settings?.welcomeText?.text}</p>
          </div>
          <div className="apps">
            <div className="apps__qr">
              <img src={`${process.env.PUBLIC_URL}/img/appsQr.png`} className="apps__qr--img" />
              <p className="apps__title">
                <Trans i18nKey="get_app" />
              </p>
            </div>
            <ul className="apps__list">
              <li className="apps__item">
                <a
                  href="https://apps.apple.com/us/app/inspace-app/id1569382208"
                  target="_blank"
                  rel="noreferrer"
                  className="apps__link"
                >
                  <AppStore className="apps__apple" />
                </a>
              </li>
              <li className="apps__item">
                <a
                  href="https://play.google.com/store/apps/details?id=app.inspace&hl=en_US&gl=US"
                  target="_blank"
                  rel="noreferrer"
                  className="apps__link"
                >
                  <GooglePlay className="apps__google" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      }
      childrenRight={
        <>
          <TodayDateTime />
          <div className="section">
            <PeopleInOffice usersAvatar={usersAvatar} countUsers={countUsers} />
            {settings.wifi?.ssid && (
              <WifiInfo
                position="right"
                login={settings.wifi.ssid}
                password={settings.wifi.password}
                encryption={settings.wifi.encryption}
                isHidden={settings.wifi.isHidden}
              />
            )}
          </div>
          <div></div>
        </>
      }
    />
  );
};

export default ReceptionPage;
